const formattedDate = (date) => {
  const temp = new Date(date* 1000) 
  return temp.toLocaleDateString("en-US")
}
 export default formattedDate;